import ToggleButton from '@mui/material/ToggleButton';
import { styled } from '@mui/material/styles';

export default styled(ToggleButton)(
  ({
    theme: {
      palette: { common, grey, primary },
      spacing,
    },
  }) => ({
    '&.MuiToggleButton-root': {
      flex: 1,
      paddingTop: spacing(1),
      paddingBottom: spacing(1),
      margin: 4,
      border: 0,
      color: primary.main,
      fontWeight: 'bold',
      backgroundColor: grey[300],
      '&.Mui-selected': {
        color: primary.main,
        backgroundColor: common.white,
        boxShadow:
          '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
      },
      '&:is(&:hover)': {
        backgroundColor: grey[200],
      },
      '&:is(&.Mui-selected:hover)': {
        backgroundColor: common.white,
      },
      '&.MuiToggleButtonGroup-groupedHorizontal:not(:last-of-type), &.MuiToggleButtonGroup-groupedHorizontal:not(:first-of-type)':
        {
          borderRadius: 5,
        },
    },
    '&.MuiToggleButton-sizeSmall': {
      paddingTop: spacing(0.5),
      paddingBottom: spacing(0.5),
    },
  }),
);
